import React from 'react';
import { Link } from 'react-router-dom';
import { Settings, HelpCircle, Shield, FileText } from 'lucide-react';
import useVersion from '@/hooks/useVersion';

const FOOTER_LINKS = [
  { label: 'Einstellungen & Verträge', to: '/portal/einstellungen', icon: Settings, testid: 'footer-link-einstellungen' },
  { label: 'Hilfe & FAQ', to: '/portal/hilfe', icon: HelpCircle, testid: 'footer-link-hilfe' },
  { label: 'Datenschutz', to: '/datenschutz', icon: Shield, testid: 'footer-link-datenschutz' },
  { label: 'Impressum', to: '/impressum', icon: FileText, testid: 'footer-link-impressum' },
];

const PortalFooter = () => {
  const { version, versionString } = useVersion();
  const buildDate = version?.buildDate
    ? new Date(version.buildDate).toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' })
    : null;

  return (
    <footer data-testid="portal-footer" className="mt-8 border-t border-gray-200 bg-white">
      <div className="max-w-[1600px] mx-auto px-4 lg:px-6 py-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-[11px] text-gray-400 order-3 md:order-1">
            © {new Date().getFullYear()} Scholze-Kurz &amp; Kurz Immobilien GmbH · Kundenportal
          </p>
          <nav className="flex flex-wrap items-center justify-center gap-x-5 gap-y-1.5 order-1 md:order-2">
            {FOOTER_LINKS.map(({ label, to, icon: Icon, testid }) => (
              <Link
                key={to}
                to={to}
                data-testid={testid}
                className="inline-flex items-center gap-1.5 text-xs text-gray-500 hover:text-brand-navy transition-colors"
              >
                <Icon className="w-3.5 h-3.5 text-brand-gold/70" />
                {label}
              </Link>
            ))}
          </nav>
          <p data-testid="footer-version" className="text-[11px] text-gray-400 tabular-nums order-2 md:order-3">
            {versionString || 'v3.0'}
            {buildDate ? ` · Stand: ${buildDate}` : ''}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default PortalFooter;
